import { DEFAULT_TOAST_DATA } from '../constants/toast';
import { IStoryData, IStoryListData, IStoriesContext } from '../interfaces/stories';
import { StoryTypeEnum } from '../types/stories';

export const MOCK_STORIES_LIST: IStoryListData[] = [
  {
    id: '1',
    title: 'Story 1',
    author: 'Author 1',
    mediaType: StoryTypeEnum.video,
    startDate: '11/12/2023',
    endDate: '12/12/2023',
    status: 'visible'
  },
  {
    id: '2',
    title: 'Story 2 Story 2 Story 2Story 2Story 2',
    author: 'test@betterfly.com',
    mediaType: StoryTypeEnum.image,
    startDate: '11/12/2023',
    endDate: '12/12/2023',
    status: 'scheduled'
  },
  {
    id: '3',
    title: 'Story 3',
    author: 'Author 2',
    mediaType: StoryTypeEnum.image,
    startDate: '11/12/2023',
    endDate: '12/12/2023',
    status: 'hidden'
  },
  {
    id: '4',
    title: 'Story 4',
    author: 'Author 2',
    mediaType: StoryTypeEnum.image,
    startDate: '11/12/2023',
    endDate: '',
    status: 'permanent'
  },
  {
    id: '5',
    title: 'Story 5',
    author: 'Author 2',
    mediaType: StoryTypeEnum.image,
    startDate: '11/12/2023',
    endDate: '12/12/2023',
    status: 'permanent'
  },
  {
    id: '6',
    title: 'Story 6',
    author: 'Author 2',
    mediaType: StoryTypeEnum.image,
    startDate: '11/12/2023',
    endDate: '12/12/2023',
    status: 'permanent'
  },
  {
    id: '7',
    title: 'Story 7',
    author: 'Author 2',
    mediaType: StoryTypeEnum.image,
    startDate: '11/12/2023',
    endDate: '12/12/2023',
    status: 'permanent'
  },
  {
    id: '8',
    title: 'Story 8',
    author: 'Author 2',
    mediaType: StoryTypeEnum.image,
    startDate: '11/12/2023',
    endDate: '12/12/2023',
    status: 'permanent'
  }
];

export const MOCK_STORIES_LIST_RESPONSE = {
  stories: MOCK_STORIES_LIST,
  totalStories: 90
};

export const MOCK_STORY_DETAILS_IMAGE: IStoryData = {
  id: '1',
  title: 'Story 1',
  author: 'Author 1',
  mediaType: StoryTypeEnum.image,
  startDate: '11/12/2023',
  endDate: '12/12/2023',
  status: 'visible',
  views: 10,
  contentUrl:
    'https://firebasestorage.googleapis.com/v0/b/content_multimedia/o/content%2FwmVEtp_2SaSNgS9fWOP53A?alt=media&token=1923778c-1cec-4a2f-9668-95149f1a2864'
};

export const MOCK_STORY_DETAILS: IStoryData = {
  id: '1',
  title: 'Story 1',
  author: 'Author 1',
  mediaType: StoryTypeEnum.video,
  startDate: '11/12/2023',
  endDate: '15/12/2023',
  status: 'visible',
  views: 10,
  contentUrl:
    'https://firebasestorage.googleapis.com/v0/b/content_multimedia/o/content%2FTask%20video_1.mp4?alt=media&token=17f6f4d8-357b-4c55-8782-0e224330962f'
};

export const STORY_FILE_MOCK = {
  video:
    'https://firebasestorage.googleapis.com/v0/b/content_multimedia/o/content%2FTask%20video_1.mp4?alt=media&token=17f6f4d8-357b-4c55-8782-0e224330962f',
  image:
    'https://firebasestorage.googleapis.com/v0/b/content_multimedia/o/content%2FwmVEtp_2SaSNgS9fWOP53A?alt=media&token=1923778c-1cec-4a2f-9668-95149f1a2864'
};

export const UPLOAD_STORY_VIDEO_MOCK_RESPONSE = {
  data: {
    url: STORY_FILE_MOCK.video
  }
};

export const UPLOAD_STORY_IMAGE_MOCK_RESPONSE = {
  data: {
    url: STORY_FILE_MOCK.image
  }
};

export const STORIES_PROVIDER_MOCK: IStoriesContext = {
  storyDuplication: undefined,
  toastData: DEFAULT_TOAST_DATA,
  openToast: false,
  changeStoryDuplication: () => {
    return;
  },
  changeToastData: () => {
    return;
  },
  changeOpenToast: () => {
    return;
  }
};
